import { Injectable } from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { ExceptionsService } from "@core-services/exceptions.service";
import { config } from "@config";

// Needs to be nicer if GQL endpoints grow in count (maybe String.includes("/graphql") is enough
const shouldCatchGqlError = (req: HttpRequest<unknown>): boolean =>
	req.url === config.apiUrlGql || req.url === config.apiUrlGqlStaking || req.url === config.apiUrlGqlBff;

// eslint-disable-next-line @angular-eslint/use-injectable-provided-in
@Injectable()
export class ErrorInterceptorService implements HttpInterceptor {
	public constructor(private exceptionsService: ExceptionsService) {}

	public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		return next
			.handle(req)
			.pipe(
				catchError((e) =>
					shouldCatchGqlError(req)
						? this.exceptionsService.catchGqlErrorAndRethrow(e)
						: this.exceptionsService.catchRestErrorAndRethrow(e)
				)
			);
	}
}
